import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import React from 'react';

import { ToolbarButton, type ToolbarButtonProps } from 'components/UI/ToolbarButton';

export interface ToolbarReloadButtonProps extends ToolbarButtonProps {
  isBusy?: boolean;
}

function ToolbarReloadButton({
  isBusy,
  ...passthruProps
}: ToolbarReloadButtonProps) {
  return (
    <ToolbarButton {...passthruProps}>
      {isBusy ? <LoadingOutlined /> : <ReloadOutlined />}
    </ToolbarButton>
  );
}

export default ToolbarReloadButton;
